import * as yup from 'yup';

import { OptimizationThresholdType } from 'features/cluster/workload-optimization/_types';

const optimizationThresholdResourceSchema = (label: string) =>
  yup.object({
    type: yup
      .mixed<OptimizationThresholdType>()
      .oneOf([
        OptimizationThresholdType.DYNAMIC,
        OptimizationThresholdType.PERCENTAGE,
      ])
      .required(),
    percentage: yup
      .number()
      .required(`${label} is required`)
      .when('type', {
        is: 'PERCENTAGE',
        then: (schema) => schema.min(0).max(100),
        otherwise: (schema) => schema.nullable(),
      }),
  });

export const optimizationThresholdValidationSchema = yup.object({
  cpu: optimizationThresholdResourceSchema('CPU'),
  memory: optimizationThresholdResourceSchema('Memory'),
});
